/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const PREVIEW_TOKEN_PARAM = 'WCPreviewToken';
export const NEW_PREVIEW_SESSION_PARAM = 'newPreviewSession';
